import React, { useEffect, useState } from "react"
import { AnimatePresence } from "framer-motion"

import speakupBlue from "assets/images/speakUpBlue.svg"
import pimeoBlue from "assets/images/pimeoBlue.svg"
import leaBlue from "assets/images/leaBlue.svg"
import * as Styles from "./ContentWithSpeakupLogo.styles"

export const ContentWithSpeakupLogo: React.FC = (props) => {
  const logos = [ speakupBlue, pimeoBlue, leaBlue ]
  const [ currentIndex, setCurrentIndex ] = useState(0)
  const [ showLogo, setShowLogo ] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setShowLogo(false)
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % logos.length)
        setShowLogo(true)
      }, 1000)
    }, 4000)

    return () => clearInterval(interval)
  }, [ logos.length ])

  return (
    <Styles.Container>
      <Styles.AnimatePresenceContainer>
        <AnimatePresence>
          {showLogo && (
            <Styles.ScrollingContainer
              key={currentIndex}
              initial={{ opacity: 0, x: "100%" }}
              animate={{ opacity: 1, x: "0" }}
              exit={{ opacity: 0, x: "-100%" }}
              transition={{ duration: 1 }}
            >
              <Styles.Logo src={logos[currentIndex]} alt="" />
            </Styles.ScrollingContainer>
          )}
        </AnimatePresence>
      </Styles.AnimatePresenceContainer>
      {props.children}
    </Styles.Container>
  )
}
